/**
 * @tabler/icons-react v2.44.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconBracketsContainStart = createReactComponent(
  "brackets-contain-start",
  "IconBracketsContainStart",
  [
    ["path", { d: "M9 4h-4v16h4", key: "svg-0" }],
    ["path", { d: "M18 16h-.01", key: "svg-1" }],
    ["path", { d: "M14 16h-.01", key: "svg-2" }],
    ["path", { d: "M10 16h-.01", key: "svg-3" }]
  ]
);

export { IconBracketsContainStart as default };
//# sourceMappingURL=IconBracketsContainStart.js.map
